// Currency formatter for GOSHI — Indian Rupees with locale-aware grouping
export const CURRENCY = "₹";

export const formatPrice = (amount) => {
  const n = Number(amount) || 0;
  return `${CURRENCY}${n.toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;
};

// Joins non-empty address fields with ", " — used in shipping/order address blocks.
export const formatAddress = (a = {}, fields = ["flat_no", "address_line1", "landmark", "area", "city", "state", "zip", "country"]) =>
  fields.map((k) => a[k]).filter(Boolean).join(", ");
